/* ===== Cenzio — sepet cekmecesinde "ikinci eser" onerisi (2026-11-02) =====
   Set indirimi (2 eser %25, 3+ eser %40) sepette yaziyordu ama eklenecek
   eser gosterilmiyordu. Burada sepetteki ilk eserin Shopify onerilerinden
   3 tanesi, sepetteki eserle AYNI boy + cerceve rengiyle gosterilir (set
   birbirine uysun) ve tek dokunusla eklenir. Oranlar window.CzOffer'dan
   (snippets/cz-offer.liquid) gelir; burada sayi yazilmaz.
   Cekmece her degisiklikte yeniden cizildigi icin kutu MutationObserver
   ile geri eklenir; oneriler urun basina bir kez cekilir.
   ======================================================================= */
(function () {
  'use strict';

  var cache = {};
  var busy = false;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function tiers() {
    return (window.CzOffer && window.CzOffer.tiers) || [];
  }

  function headline(count) {
    var t = tiers();
    var next = t.filter(function (x) { return x.n > count; })[0];
    if (!next) return 'Complete the wall';
    if (next.n - count === 1) {
      return count === 1
        ? 'Add a second print, save ' + next.p + '% on both'
        : 'Add one more, save ' + next.p + '% on all ' + next.n;
    }
    return 'Add ' + (next.n - count) + ' more, save ' + next.p + '%';
  }

  function recs(productId) {
    if (cache[productId]) return cache[productId];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cache[productId] = fetch(root + 'recommendations/products.json?product_id=' + productId +
      '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
    return cache[productId];
  }

  /* Sepetteki eserle ayni secenekler (boy / derinlik / cerceve rengi). */
  function matchVariant(product, wanted) {
    var avail = product.variants.filter(function (v) { return v.available; });
    var key = (wanted || []).join('|');
    return avail.filter(function (v) { return v.options.join('|') === key; })[0] || avail[0];
  }

  function card(p, v) {
    var a = document.createElement('div');
    a.className = 'cz-up__item';
    var img = p.featured_image || '';
    a.innerHTML =
      '<a class="cz-up__img" href="' + p.url + '">' +
        (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=220" alt="" loading="lazy" width="110" height="138">' : '') +
      '</a>' +
      '<a class="cz-up__name" href="' + p.url + '"></a>' +
      '<span class="cz-up__price">' + money(v.price) + '</span>' +
      '<button type="button" class="cz-up__add" data-id="' + v.id + '">+ Add</button>';
    a.querySelector('.cz-up__name').textContent = p.title.split(/\s+[—|-]\s+/)[0];
    return a;
  }

  function add(btn) {
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status || !d.sections) throw new Error(d.description || 'add failed');
        if (drawer && drawer.renderContents) drawer.renderContents(d);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Add';
      });
  }

  function render() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || busy) return;
    var form = drawer.querySelector('cart-drawer-items .cart-drawer__form');
    var old = drawer.querySelector('.cz-up');
    if (!form) { if (old) old.remove(); return; }
    if (old && old.dataset.ready) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prints = cart.items.filter(function (i) { return !i.gift_card; });
        if (!prints.length) return null;
        var first = prints[0];
        var printCount = prints.reduce(function (n, i) { return n + i.quantity; }, 0);
        var inCart = cart.items.map(function (i) { return i.product_id; });
        return recs(first.product_id).then(function (list) {
          var picks = list.filter(function (p) {
            return inCart.indexOf(p.id) === -1 && p.available;
          }).slice(0, 3);
          if (!picks.length) return null;
          var box = document.createElement('div');
          box.className = 'cz-up';
          box.dataset.ready = '1';
          var h = document.createElement('p');
          h.className = 'cz-up__head';
          h.textContent = headline(printCount);
          var row = document.createElement('div');
          row.className = 'cz-up__row';
          picks.forEach(function (p) {
            var v = matchVariant(p, first.variant_options);
            if (v) row.appendChild(card(p, v));
          });
          box.appendChild(h);
          box.appendChild(row);
          return box;
        });
      })
      .then(function (box) {
        var cur = drawer.querySelector('.cz-up');
        if (cur) cur.remove();
        /* Kaydirilan alana, urun listesinin hemen altina (alt bolume degil:
           telefonda sabit alt bolum buyuyunce urun satiri ekrandan itiliyordu) */
        var form = drawer.querySelector('cart-drawer-items .cart-drawer__form');
        if (box && form) form.parentNode.insertBefore(box, form.nextSibling);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cz-up__add');
      if (b) { e.preventDefault(); add(b); }
    });
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(render, 120);
    }).observe(drawer, { childList: true, subtree: true });
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
